<app-audit-subbar></app-audit-subbar>

<div class="audit-tab-body" style="position: relative">
  <div class="cat-wrap">
    <!-- No data -->
    <div class="cat-empty" *ngIf="!hasData && !isLoading">
      <p>No behavioral science data available for this audit yet.</p>
    </div>

    <ng-container *ngIf="hasData">
      <!-- ── Header card: score + stats + benchmark + trend ── -->
      <div class="cat-head-card">
        <div class="cat-head-grid">
          <!-- Left: stats + benchmark -->
          <div class="cat-head-left">
            <div class="cat-head-title">
              <h2>{{ label }}</h2>
            </div>
            <p class="cat-head-desc">
              {{ description
              }}<span *ngIf="hasComp">
                Benchmarked against {{ compName }}.</span
              >
            </p>

            <div class="bs-stats">
              <div class="bs-stat">
                <div class="bs-stat-label">Behavioral score</div>
                <div class="bs-stat-val">
                  <span
                    class="bs-stat-num"
                    [style.color]="impactColor(score)"
                    >{{ score }}</span
                  ><span class="bs-stat-unit">/100</span>
                </div>
              </div>
              <div class="bs-stat">
                <div class="bs-stat-label">Mechanisms active</div>
                <div class="bs-stat-val">
                  <span class="bs-stat-num">{{ activeCount }}</span
                  ><span class="bs-stat-unit">/{{ totalCount }} relevant</span>
                </div>
              </div>
              <div class="bs-stat">
                <div class="bs-stat-label">Largest gap</div>
                <div class="bs-stat-val">
                  <span class="bs-stat-text">{{ largestGapText }}</span>
                </div>
              </div>
            </div>

            <div class="cat-bench" *ngIf="benchBars.length">
              <div class="cat-bench-head" *ngIf="hasComp">
                <span>Benchmark</span>
                <span [style.color]="leadColor">{{ leadText }}</span>
              </div>

              <div class="cat-bar-row" *ngFor="let b of benchBars">
                <span class="cat-bar-label">{{ b.label }}</span>
                <div class="cat-bar-track">
                  <div
                    class="cat-bar-fill"
                    [style.width]="b.width"
                    [style.background]="b.color"
                  ></div>
                </div>
                <span class="cat-bar-val" [class.cat-bar-val--muted]="!b.isYou"
                  >{{ b.score
                  }}<small class="cat-bar-val-max">/100</small></span
                >
              </div>
            </div>
          </div>

          <!-- Right: score-over-time trend (biweekly audits with >1 data point
             only; hidden for one-time audits and single-point histories) -->
          <div class="cat-head-right" *ngIf="trendHasData">
            <div class="cat-trend-head">
              <span class="cat-trend-title">Score over time</span>
              <div class="wa-legend" *ngIf="trendLegend?.length">
                <button
                  type="button"
                  class="wa-legend-item"
                  *ngFor="let l of trendLegend"
                  [class.off]="!l.isYou && !l.visible"
                  [class.locked]="l.isYou"
                  (click)="toggleTrendLine(l)"
                >
                  <span
                    class="wa-legend-dash"
                    [style.background]="l.color"
                  ></span>
                  {{ l.label }}
                </button>
              </div>
            </div>
            <div class="cat-trend-body">
              <google-chart [data]="trendLineChart"></google-chart>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Cluster filter chips ── -->
      <div class="tab-chip-container" *ngIf="clusters.length > 2">
        <button
          *ngFor="let c of clusters"
          class="tab-chip"
          [class.active]="selectedCluster == c.key"
          (click)="selectCluster(c.key)"
        >
          {{ c.label }}
        </button>
      </div>

      <!-- ── Mechanisms + selected detail ── -->
      <div class="cat-detail-grid">
        <!-- Mechanism list -->
        <div class="cat-sub-list">
          <div
            *ngFor="let m of visibleMechanisms"
            class="cat-sub-card"
            [class.selected]="m.selected"
            (click)="selectMechanism(m)"
          >
            <div class="cat-sub-top">
              <span class="cat-sub-name">{{ m.name }}</span>
              <span class="cat-sub-right">
                <span class="bs-arrow-score">
                  <span [style.color]="m.scoreColor">{{ m.score }}</span>
                  <span class="bs-arrow">→</span>
                  <span [style.color]="m.targetColor">{{ m.target }}</span>
                </span>
              </span>
            </div>
            <div class="cat-sub-bottom">
              <span class="bs-sub-meta">
                {{ m.activeCount }} active · {{ m.untappedCount }} untapped
              </span>
              <span
                class="cat-sub-comp"
                *ngIf="m.hasComp"
                [style.color]="m.compColor"
              >
                {{ m.compArrow }} {{ m.comp }}
                <span class="cat-sub-muted">{{ compName }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Selected mechanism -->
        <div class="cat-sel-card" *ngIf="selectedMechanism">
          <div class="cat-sel-head">
            <div>
              <h3>{{ selectedMechanism.name }}</h3>
              <p>{{ selectedMechanism.description }}</p>
              <span
                class="bs-cluster-pill"
                *ngIf="selectedMechanism.clusterLabel"
                >{{ selectedMechanism.clusterLabel }}</span
              >
            </div>
            <div class="cat-sel-stats">
              <div class="cat-sel-stat">
                <div class="cat-sel-stat-label">Your score</div>
                <div class="cat-sel-stat-val">
                  {{ selectedMechanism.score }}
                </div>
              </div>
              <div class="cat-sel-stat" *ngIf="selectedMechanism.hasComp">
                <div class="cat-sel-stat-label">{{ compName }}</div>
                <div
                  class="cat-sel-stat-val"
                  [style.color]="selectedMechanism.compColor"
                >
                  {{ selectedMechanism.compArrow }} {{ selectedMechanism.comp }}
                </div>
              </div>
              <div
                class="cat-sel-stat"
                *ngIf="selectedMechanism.target !== null"
              >
                <div class="cat-sel-stat-label">Potential</div>
                <div class="cat-sel-stat-val cat-sel-stat-val--good">
                  {{ selectedMechanism.target }}
                </div>
              </div>
            </div>
          </div>

          <div class="cat-sel-divider">
            <ng-container *ngIf="!selectedMechanism.hasComp"
              >What the audit found for </ng-container
            ><ng-container *ngIf="selectedMechanism.hasComp"
              >What the {{ scopeLabel }} audit found for </ng-container
            ><b>{{ selectedMechanism.name }}</b>
            <!-- Which side the two columns describe (only with a competitor). -->
            <div class="bs-scope-chips" *ngIf="selectedMechanism.hasComp">
              <button
                class="tab-chip"
                [class.active]="detailScope == 'target'"
                (click)="setDetailScope('target')"
              >
                Your site
              </button>
              <button
                class="tab-chip"
                [class.active]="detailScope == 'competitor'"
                (click)="setDetailScope('competitor')"
              >
                {{ compName }}
              </button>
            </div>
          </div>

          <div class="cat-sel-cols">
            <!-- Untapped potential -->
            <div class="cat-sel-col">
              <div class="cat-sel-col-head">
                <span
                  ><span class="cat-dot" [style.background]="red"></span
                  >Untapped potential</span
                >
                <span class="cat-sel-col-score" [style.color]="red">{{
                  selectedMechanism.untapped.length
                }}</span>
              </div>

              <div class="cat-sig-scroll">
                <div
                  class="cat-sig cat-sig--bad"
                  *ngFor="let o of selectedMechanism.untapped"
                >
                  <div class="cat-sig-title">
                    {{ o.title }}
                    <span
                      class="bs-ethical"
                      *ngIf="o.ethical"
                      matTooltip="Flagged as potentially manipulative — only ship this if the claim is genuine."
                      matTooltipPosition="above"
                      >Ethics check</span
                    >
                  </div>
                  <div class="cat-sig-desc" *ngIf="o.observation">
                    {{ o.observation }}
                  </div>

                  <button
                    type="button"
                    class="bs-more"
                    *ngIf="o.rationale || o.recommendation"
                    (click)="toggleItem(o)"
                  >
                    {{
                      o.expanded ? "Hide details" : "Why it works & what to do"
                    }}<mat-icon>{{
                      o.expanded ? "expand_less" : "expand_more"
                    }}</mat-icon>
                  </button>

                  <div class="bs-detail" *ngIf="o.expanded">
                    <div class="bs-detail-block" *ngIf="o.rationale">
                      <div class="bs-detail-label">Why it works</div>
                      <div class="bs-detail-text">{{ o.rationale }}</div>
                    </div>
                    <div class="bs-detail-block" *ngIf="o.recommendation">
                      <div class="bs-detail-label">What to do</div>
                      <div class="bs-detail-text">{{ o.recommendation }}</div>
                    </div>
                  </div>

                  <div class="bs-pages" *ngIf="o.pages.length">
                    <span class="bs-page" *ngFor="let p of o.pages">{{
                      p
                    }}</span>
                  </div>
                </div>

                <div
                  class="cat-sig-none"
                  *ngIf="!selectedMechanism.untapped.length"
                >
                  No untapped potential found for this mechanism.
                </div>
              </div>
            </div>

            <!-- Actively used -->
            <div class="cat-sel-col">
              <div class="cat-sel-col-head">
                <span
                  ><span class="cat-dot" [style.background]="green"></span
                  >Actively used</span
                >
                <span class="cat-sel-col-score" [style.color]="green">{{
                  selectedMechanism.active.length
                }}</span>
              </div>

              <div class="cat-sig-scroll">
                <div
                  class="cat-sig cat-sig--good"
                  *ngFor="let o of selectedMechanism.active"
                >
                  <div class="cat-sig-title">{{ o.title }}</div>
                  <div class="cat-sig-desc" *ngIf="o.description">
                    {{ o.description }}
                  </div>
                  <div class="bs-pages" *ngIf="o.pages.length">
                    <span class="bs-page" *ngFor="let p of o.pages">{{
                      p
                    }}</span>
                  </div>
                </div>

                <div
                  class="cat-sig-none"
                  *ngIf="!selectedMechanism.active.length"
                >
                  This mechanism isn't used anywhere in the audited flows.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Top opportunities ── -->
      <div class="cat-sel-card" *ngIf="topOpportunities.length">
        <div class="cat-sel-head">
          <div>
            <h3>Top opportunities</h3>
            <p>
              The highest-leverage behavioral changes across the audited funnel,
              ranked by expected return.
            </p>
          </div>
        </div>

        <div class="bs-opp-list">
          <div class="bs-opp" *ngFor="let o of topOpportunities">
            <div class="bs-opp-top">
              <div class="bs-opp-title">
                {{ o.mechanism }}
                <span class="bs-opp-page" *ngIf="o.page">· {{ o.page }}</span>
              </div>
              <div class="bs-opp-tags">
                <span
                  class="bs-tag"
                  *ngIf="o.impact"
                  [style.color]="o.impactColor"
                  [style.background]="rgba(o.impactColor, 0.13)"
                  >{{ o.impact }} impact</span
                >
                <span
                  class="bs-tag"
                  *ngIf="o.effort"
                  [style.color]="o.effortColor"
                  [style.background]="rgba(o.effortColor, 0.13)"
                  >{{ o.effort }} effort</span
                >
              </div>
            </div>
            <div class="bs-opp-rationale">{{ o.rationale }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Competitor switch overlay (scoped to the content, below the sub-bar) -->
  <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="loading-data-overlay" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
